/* import __COLOCATED_TEMPLATE__ from './compact.hbs'; */
import PlaylistPlayerAbstract from 'seshy/components/playlist/player/abstract';

export default class PlaylistPlayerCompactComponent extends PlaylistPlayerAbstract {}
